import {
  service
} from '@/utils/request'

export default {
  //获取医生佣金列表
  getDocCommissionList: (params) => {
    return service({
      url: '/cloud/community/admin/commission/doctorCommissionList',
      method: 'get',
      params: params
    })
  },
  //获取统计数据
  getTotalDataApi: (params) => {
    return service({
      url: '/cloud/community/admin/commission/stat',
      method: 'get',
      params: params
    })
  },
  //获取绑定孕妈详情
  getBindMomDetailList: (params) => {
    return service({
      url: '/cloud/community/admin/commission/momCommissionList',
      method: 'get',
      params: params
    })
  },
  //更改备注
  updateDoctorRemark: (data) => {
    return service({
        url: '/cloud/community/admin/commission/updateDoctorRemark',
        method: 'post',
        data: data
      })
  },
  //更改黑名单状态
  changeBlackStatus: (data) => {
    return service({
        url: '/cloud/community/admin/commission/doctorVerify',
        method: 'post',
        data: data
      })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/docBrokerage.js